module.exports = __webpack_public_path__ + "img/qr-code.18b4cb1d.svg";